<template>
  <div id="home" @click.stop="hideUserInfo" v-loading="isReloadLang">
    <a-layout
      id="components-layout-demo-custom-trigger"
      v-if="!$route.meta.hideHead"
    >
      <a-layout-sider
        v-model="collapsed"
        :trigger="null"
        collapsible
        style="background: #fff"
        :collapsedWidth="collapsedWidth"
        :width="spreadWidth"
      >
        <div class="logo pt10 pl16" v-if="!webToQt">
          <img src="../assets/icon/site-logo.jpg" width="40" height="40" />
          <div class="text" v-show="!collapsed">
            <h3>
              <span style="font-size: 20px" :title="mainHeadTitleText">{{
                mainHeadTitleText
              }}</span>
              <span class="version">{{ version }}</span>
            </h3>
            <span :title="mainHeadSubTitleText">{{
              mainHeadSubTitleText
            }}</span>
          </div>
        </div>
        <a-menu
          theme="light"
          mode="inline"
          :defaultOpenKeys="['sub1', 'sub2', 'sub3', 'sub4']"
          :selectedKeys="activeMenu"
        >
          <a-sub-menu key="sub1" class="item-sub-menu">
            <span slot="title"
              ><i class="iconfont icon-prduction"></i>
              <span
                v-show="!collapsed"
                id="produce_optimize_btn"
                :title="translateLang('main.sideBar.title')"
                >{{ $t('main.sideBar.title') }}</span
              >
            </span>
            <a-menu-item key="material" :selectable="false">
              <router-link
                to="/materialList"
                id="open-material_btn"
                :title="translateLang('main.sideBar.materialList')"
              >
                {{ $t('main.sideBar.materialList') }}
              </router-link>
            </a-menu-item>
            <a-menu-item key="draw" :disabled="!ableViewPaiban">
              <router-link
                to="/newPaiban"
                id="typesetting_scheme_btn"
                :title="translateLang('main.sideBar.paibanResult')"
              >
                {{ $t('main.sideBar.paibanResult') }}
              </router-link>
            </a-menu-item>
            <a-menu-item
              key="printTag"
              :disabled="!hasPrintTag || !isCanPrintTag"
            >
              <router-link
                to="/printTag"
                id="print_tag_btn"
                :title="translateLang('main.sideBar.printTag')"
              >
                {{ $t('main.sideBar.printTag') }}
              </router-link>
            </a-menu-item>
            <!-- 角标：排版中和等待中的任务数，与 paibanTaskStore.paibanTaskRunningAndPendingCount 同步 -->
            <a-menu-item
              key="paibanTask"
              class="paiban-task-menu-item"
              :disabled="
                !checkUserPermissions([USER_PERMISSION_KEY.CREATE_PAIBAN_TASK])
              "
            >
              <g-paid-feature
                block
                :iconStyle="{ right: '50px' }"
                :permission-keys="[USER_PERMISSION_KEY.CREATE_PAIBAN_TASK]"
              >
                <router-link
                  to="/paibanTask"
                  id="paiban_task_btn"
                  class="paiban-task-menu-item__link"
                  :class="{
                    __disabled: !checkUserPermissions([
                      USER_PERMISSION_KEY.CREATE_PAIBAN_TASK,
                    ]),
                  }"
                  :title="$translateLang('排版任务')"
                  :disabled="
                    !checkUserPermissions([
                      USER_PERMISSION_KEY.CREATE_PAIBAN_TASK,
                    ])
                  "
                >
                  {{ $translateLang('排版任务') }}

                  <a-badge
                    v-if="paibanTaskRunningAndPendingCount"
                    :count="paibanTaskRunningAndPendingCount"
                    :overflow-count="99"
                    class="paiban-task-menu-item__badge mr5"
                  />
                </router-link>
              </g-paid-feature>
            </a-menu-item>
            <a-menu-item key="history">
              <router-link
                to="/paibanHistory"
                id="save_history_btn"
                :title="translateLang('main.sideBar.history')"
              >
                {{ $t('main.sideBar.history') }}
              </router-link>
            </a-menu-item>
            <a-menu-item key="workShop" class="factory relative">
              <!-- <div
                class="factory-tip absolute pv1 ph5 br5 r20"
                style="background-color: #f9e0c7; line-height: 20px"
                :title="translateLang('main.sideBar.limitDate')"
              >
                {{ $t('main.sideBar.limitDate') }}
              </div> -->
              <router-link
                to="/workShopProduction"
                id="equipment_Online_btn"
                :title="translateLang('main.head.workeShop')"
              >
                {{ $t('main.head.workeShop') }}
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2" class="item-sub-menu">
            <span slot="title"
              ><i class="iconfont icon-equipment"></i>
              <span
                v-show="!collapsed"
                :title="translateLang('main.head.productionLine')"
                >{{ $t('main.head.productionLine') }}</span
              >
            </span>
            <a-menu-item key="equip">
              <router-link
                to="/equipment"
                id="equipment_docking_btn"
                :title="translateLang('main.head.prolineManager')"
              >
                {{ $t('main.head.prolineManager') }}
              </router-link>
            </a-menu-item>
            <a-menu-item
              key="preLayoutSetting"
              class="preLayout-setting relative"
            >
              <div
                class="factory-tip absolute pv1 ph5 br5 b20"
                style="background-color: #f9e0c7; line-height: 20px"
                :title="translateLang('main.sideBar.limitDate')"
              >
                {{ $t('main.sideBar.limitDate') }}
              </div>
              <router-link
                to="/preLayoutSetting"
                id="pre_layout_setting_btn"
                :title="translateLang('preLayoutSetting.title')"
              >
                {{ $t('preLayoutSetting.title') }}
              </router-link>
              <!-- TODO wc 新功能展示 -->
              <!-- <div
                class="inline-block w100"
                style="padding-left: 40px"
                to="/preLayoutSetting"
                id="pre_layout_setting_btn"
                :title="translateLang('preLayoutSetting.title')"
                @click="handleClickPreSetting"
              >
                <div class="inline-block flex flex-cross--center">
                  <span class="inline-block ellipsis" style="max-width: 100%">{{
                    $t('preLayoutSetting.title')
                  }}</span>
                  <span
                    v-if="!isNewSettingRecord"
                    class="inline-block ml10 new_button_text ellipsis"
                    :title="translateLang('common.newSetting')"
                    >{{ $t('common.newSetting') }}</span
                  >
                </div>
              </div> -->
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub3" class="item-sub-menu">
            <span slot="title"
              ><i class="iconfont icon-mobanguanli"></i>
              <span
                v-show="!collapsed"
                id="setting_btn"
                :title="translateLang('main.head.setting')"
                >{{ $t('main.head.materialManager') }}</span
              >
            </span>
            <a-menu-item key="baseMaterial">
              <router-link
                to="/baseMaterial"
                id="initial_plank_manage_btn"
                :title="translateLang('main.head.plankManager')"
              >
                {{ $t('main.head.plankManager') }}
              </router-link>
            </a-menu-item>
            <a-menu-item key="bujianManage">
              <router-link
                to="/bujianManage"
                id="bujian_manage_btn"
                :title="translateLang('main.head.suplumentManager')"
              >
                {{ $t('main.head.suplumentManager') }}
              </router-link>
            </a-menu-item>
            <a-menu-item key="surplus">
              <router-link
                to="/supplusStorage"
                id="excess_material_manage_btn"
                :title="translateLang('main.sideBar.surplusManager')"
              >
                {{ $t('main.sideBar.surplusManager') }}
              </router-link>
            </a-menu-item>
          </a-sub-menu>

          <a-sub-menu key="sub4" class="item-sub-menu">
            <span slot="title"
              ><i class="iconfont icon-set_up01"></i>
              <span v-show="!collapsed" id="setting_btn">{{
                $t('main.head.setting')
              }}</span>
            </span>

            <a-menu-item key="tagMenage">
              <router-link
                to="/printTag?from=temp"
                id="tag_manage_btn"
                :title="translateLang('main.head.tagManager')"
              >
                {{ $t('main.head.tagManager') }}
              </router-link>
            </a-menu-item>
            <a-menu-item key="fileManage">
              <router-link
                to="/fileManage"
                id="file_manage_btn"
                :title="translateLang('main.head.fileManager')"
                >{{ $t('main.head.fileManager') }}</router-link
              >
            </a-menu-item>
            <a-menu-item key="paibanImgMenage">
              <!-- <newContent> -->
              <router-link
                to="/paibanImg?from=temp"
                id="paiban_img_manage_btn"
                :title="$translateLang('排版图管理')"
                style="display: inline-block; height: 30px; width: 169px"
              >
                {{ $translateLang('排版图管理') }}
              </router-link>
              <!-- </newContent> -->
            </a-menu-item>
            <!-- 更多设置 -->
            <a-menu-item key="moreSettings">
              <router-link
                to="/moreSettings"
                id="more_settings_btn"
                v-bp="'moreSettings:click_more_settings'"
                >{{ $t('main.sideBar.moreSettings') }}</router-link
              >
            </a-menu-item>
          </a-sub-menu>

          <!-- 发现 -->
          <a-menu-item
            key="find"
            class="deep_item"
            style="margin-top: 80px"
            v-if="webToQt"
            @click="findPopVisibel = !findPopVisibel"
          >
            <div class="deepbox">
              <span class="title-text"
                ><a-icon type="compass" /> {{ $t('main.head.find') }}</span
              >
              <a-popover placement="right" v-model="findPopVisibel">
                <template slot="content">
                  <p @click="handleOpenNotice">
                    <span id="announcement_btn">
                      {{ $t('main.head.notice') }}
                    </span>
                  </p>

                  <p
                    @click="hanlerOpenImportFuncModal"
                    v-bp="'find:importFunc'"
                  >
                    <span id="announcement_btn">
                      {{ $t('main.head.importFunc') }}
                    </span>
                  </p>

                  <p @click="handleGotoOfficialWebsite">
                    <span id="announcement_btn">
                      {{ $t('main.head.enterOfficial') }}
                    </span>
                  </p>

                  <p @click="handleGotoOfficialEquipEnvironment">
                    <span id="announcement_btn">
                      {{ $t('main.head.equipment') }}
                    </span>
                  </p>

                  <p @click="handleGotoThinkerxHome">
                    <span id="announcement_btn">
                      {{ $t('main.head.enterThinkerOfficial') }}
                    </span>
                  </p>
                </template>
              </a-popover>
            </div>
          </a-menu-item>

          <!-- 翻译 -->
          <a-menu-item
            key="lang"
            class="deep_item"
            style="display: flex; justify-content: space-between"
            v-if="webToQt && !onlyShowChineseLang"
            @click="langPopVisibel = !langPopVisibel"
          >
            <div class="deepbox">
              <span class="title-text">{{ langTitle }} </span>
              <a-popover
                overlayClassName="lang-popover"
                placement="right"
                trigger="click"
                color="black"
                v-model="langPopVisibel"
              >
                <template #title>
                  <div
                    class="flex flex-dir--top flex-cross--top lang-popover-title w100"
                  >
                    <a-button
                      type="link"
                      class="lang-link-btn w100"
                      v-for="item in langList"
                      :key="item.value"
                      :id="`lang_select_${item.value}`"
                      @click="
                        $refs.topNav.handleChangeLang(item.value)
                        langPopVisibel = false
                        langTitle = item.name
                      "
                    >
                      {{ item.name }}
                    </a-button>
                  </div>
                </template>
                <template #content>
                  <div
                    style="padding: 4px 8px; cursor: pointer"
                    @mousedown="(e) => e.preventDefault()"
                    id="edit_lang_btn"
                    class="color-f"
                  >
                    <!-- <i class="iconfont icon-edit_02"></i> -->
                    {{ $t('common.editTrans') }}
                  </div>
                </template>
                <div style="height: 80%" class="flex flex-cross--center"></div>
              </a-popover>
            </div>
            <a-icon type="setting" />
          </a-menu-item>

          <a-menu-item key="paibanCommune" v-if="webToQt" class="deep_item">
            <div @click="handleToSfeCommune" class="deepbox">
              <div>{{ $translateLang('排版交流群') }}</div>
            </div>
          </a-menu-item>
          <!-- deepseek 暂时注释 -->
          <!-- <a-menu-item key="deepseek" v-if="isGG" class="deep_item">
            <div @click="handleToSfe" class="deepbox">
              <img src="../assets//image/deepseek.png" />
              <div>{{ $t('main.sideBar.deepSeekTitle') }}</div>
            </div>
          </a-menu-item> -->
        </a-menu>

        <div
          id="feedback_showFeedback_div"
          @click="handleShowFeedback"
          class="fixed flex flex-main--center flex-cross--center b20 cursor-pointer"
        >
          <i class="el-icon-s-comment"></i>
        </div>
      </a-layout-sider>
      <a-layout class="flex-box--1 flex flex-dir--top">
        <a-layout-header
          style="height: 60px; padding: 0; background: #212121"
          v-show="!webToQt"
        >
          <div class="flex flex-cross--center">
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
            <!-- <GBreadcrumb></GBreadcrumb> -->
            <a-button
              type="link"
              class="topNav-btn"
              :class="{ 'active-topNav': activeTopNav == 'taskList' }"
              @click="handleTaskList"
              id="topNav_taskList_btn"
              :title="translateLang('main.head.task')"
              >{{ $t('main.head.task') }}</a-button
            >
            <a-button
              type="link"
              class="topNav-text"
              :disabled="!ableViewPaiban"
              :class="{ active: !ableViewPaiban }"
              @click="handleToPaiban"
              :title="translateLang('main.head.arrange')"
              >{{ $t('main.head.arrange') }}</a-button
            >
            <a-button
              type="link"
              class="topNav-text"
              @click="handleToSurplus"
              :title="translateLang('main.head.surplus')"
              >{{ $t('main.head.surplus') }}</a-button
            >
          </div>
          <div style="line-height: 1; flex: 1">
            <div class="w100 flex flex-main--right">
              <transition name="trigger-fade">
                <div class="search-container" v-if="isShowSearch">
                  <div
                    class="search-trigger"
                    @click="handleOpenSearch"
                    :title="$translateLang('输入关键词搜索') + '...'"
                  >
                    <a-icon type="search" class="trigger-icon" />
                    <span class="trigger-text ellipsis"
                      >{{ $translateLang('输入关键词搜索') }}...</span
                    >
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <top-nav
            @onReloadLang="handleReloadLang"
            @onOpenNotice="handleOpenNotice"
            ref="topNav"
          />
        </a-layout-header>
        <a-layout-content
          :style="layoutMainStyle"
          ref="layout_main"
          class="flex-box--1"
        >
          <!-- 缓存标签打印，防止每次进入组件都会创建 -->
          <keep-alive :include="['printTag', 'paibanImg']">
            <router-view
              :key="
                ['/newPaiban', '/printTag', '/editTagTem'].includes($route.path)
                  ? $route.path
                  : $route.fullPath
              "
            />
          </keep-alive>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <!-- <topNav ref="top_nav" :nowNavItem="nowNavItem" :showTiangong="showTiangong" v-if="navShow"></topNav> -->
    <router-view v-else v-on:getNoReadNotice="getNoReadNotice" />
    <!-- 公告 -->
    <notice ref="noticeRef"></notice>
    <!-- 重要功能宣传 -->
    <MImportFuncModal />
    <GFeedback
      :showFeedback="showFeedback"
      @handleFeedback="handleFeedback"
      ref="feedback"
    ></GFeedback>
    <!-- 全局通知小球 -->
    <g-global-progress-notice-ball> </g-global-progress-notice-ball>
    <!-- 创建排版任务时，卡片从弹窗按钮飞向侧栏「排版任务」入口 -->
    <g-paiban-task-fly />
    <!-- 全局搜索 -->
    <g-search ref="gSearchRef" @onChange="handleSearchChange" />
  </div>
</template>

<script>
import { buryPoint } from '@/apis/common/buryPoint'
import imgWrite from '@/assets/image/write.png'
import { checkUserPermissions } from '@/auth/user_function'
import GFeedback from '@/components/g-feedback'
import GGlobalProgressNoticeBall from '@/components/g-global-progress-notice-ball.vue'
import GPaibanTaskFly from '@/components/g-paiban-task-fly.vue'
import GPaidFeature from '@/components/g-paid-feature.vue'
import GSearch from '@/components/g-search/index.vue'
import MImportFuncModal from '@/components/importFunc/m-importFuncModal.vue'
import NewContent from '@/components/newContent.vue'
import notice from '@/components/notice'
import topNav from '@/components/topNav.vue'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { compareVersions } from '@/util/versionCompare'
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'

import { createTask } from '../views/taskList/util/dealData'

//语言列表
export default {
  components: {
    topNav,
    notice,
    GFeedback,
    GGlobalProgressNoticeBall,
    GPaibanTaskFly,
    NewContent,
    MImportFuncModal,
    GSearch,
    GPaidFeature,
  },
  data() {
    return {
      findPopVisibel: false,
      langPopVisibel: false,
      langTitle: '中文(Chinese)',
      langList: [
        {
          name: '中文(Chinese)',
          value: 'zh',
        },
        {
          name: '英文(English)',
          value: 'en',
        },
        { name: '西班牙语(Espanol)', value: 'es' },
        { name: '阿拉伯语(العربية)', value: 'ar' },
        { name: '哈萨克语(Қазақ тілі)', value: 'kz' },
        { name: '越南语(Tiếng Việt)', value: 'vi' },
        { name: '泰语(ภาษาไทย)', value: 'th' },
        { name: '印尼语(Bahasa Indonesia)', value: 'id' },
        { name: '维语(ئۇيغۇر تىلى)', value: 'ug' },
        { name: '繁体中文(Chinese Traditional)', value: 'zh_hant' },
        { name: '俄罗斯语(Русский язык)', value: 'ru' },
        { name: '韩语(한국어)', value: 'kor' },
        { name: '缅甸语(မြန်မာဘာသာ)', value: 'bur' },
        { name: '孟加拉语(বাংলা)', value: 'ben' },
        { name: '土耳其语(Türkçe)', value: 'tr' },
        { name: '柬埔寨语(ភាសាខ្មែរ)', value: 'km' },
      ],
      webToQt: false,
      nowNavItem: 'equipment',
      showTiangong: false,
      showHead: true,
      collapsed: false,
      // 左边导航栏展开宽度
      spreadWidth: 200,
      // 左边导航栏收起宽度
      collapsedWidth: 80,
      // 版本号
      version: '',
      img: {
        imgWrite,
      },
      showFeedback: false,
      sendTaskModal: null,
      isReloadLang: false,
      isNewSettingRecord: false,
      /** 是否显示全局搜索按钮(和内部弹窗显示相反记录) */
      isShowSearch: true,
      USER_PERMISSION_KEY: USER_PERMISSION_KEY,
    }
  },
  computed: {
    ...mapState([
      'hasSendToTask',
      'preLayoutData',
      'isCanPrintTag',
      'isShowFindPop',
    ]),
    /** 侧栏排版任务菜单角标：未完成（非 completed）任务条数 */
    paibanTaskRunningAndPendingCount() {
      return this.$store.getters['paibanTaskStore/runningAndPendingCount']
    },
    showUnreadIcon() {
      return this.$store.state.noReadNotice
    },
    onlyShowChineseLang() {
      return !!this.$store.state.userPermissions?.only_show_chinese_lang
    },
    navShow() {
      let routeMetaNav = this.$route.meta.nav
      return routeMetaNav ? true : false
    },
    // 是否可以查看排版页面
    ableViewPaiban() {
      if (this.$store.state.paibanData.length) {
        return true
      } else {
        return false
      }
    },
    // 是否可以查看打印标签
    hasPrintTag() {
      return this.$store.state.hasPrintTag
    },
    layoutMainStyle() {
      let width = this.collapsed ? this.collapsedWidth : this.spreadWidth
      return {
        margin: '0',
        padding: '0',
        position: 'relative',
        height: 'calc(100vh - 60px)',
        width: `calc(100vw - ${width}px)`,
        overflowX: 'auto',
        background: '#fff',
      }
    },
    // 顶部激活按钮
    activeTopNav() {
      let path = this.$route.path.replace('/', '')
      return path
    },
    // 标签页面通过菜单进入活跃按钮不同
    activeMenu() {
      let path
      if (
        this.$route.path == '/printTag' ||
        this.$route.path == '/editTagTem'
      ) {
        path = this.$route.query.from ? 'tagMenage' : this.$route.meta.nav
      } else if (
        this.$route.path == '/paibanImg' ||
        this.$route.path == '/editPaibanImg'
      ) {
        path = this.$route.query.from ? 'paibanImgMenage' : this.$route.meta.nav
      } else if (this.$route.path == '/taskList') {
        path = ''
      } else {
        path = this.$route.meta.nav
      }
      return [path]
    },
    isGG() {
      const userInfo = this.$store.state.userInfo
      const { platform, userPlatform } = userInfo
      return userPlatform === 'guigui' || platform === 0
    },
    /** 侧栏 Logo 主标题：仅简体/繁体走中文包，其余统一英文 */
    mainHeadTitleText() {
      const loc = this.$i18n?.locale
      if (loc === 'zh' || loc === 'zh_hant') {
        return this.$t('main.head.title')
      }
      return this.$i18n.t('main.head.title', 'en')
    },
    /** 侧栏 Logo 副标题：仅简体/繁体走中文包，其余统一英文 */
    mainHeadSubTitleText() {
      const loc = this.$i18n?.locale
      if (loc === 'zh' || loc === 'zh_hant') {
        return this.$t('main.head.subTitle')
      }
      return this.$i18n.t('main.head.subTitle', 'en')
    },
  },
  methods: {
    ...mapMutations(['setNewTags', 'setHasSendToTask']),
    checkUserPermissions(keys) {
      return checkUserPermissions(keys) === true
    },
    handleSearchChange(newVal) {
      this.isShowSearch = !newVal
    },
    handleOpenSearch() {
      this.$refs.gSearchRef?.open()
    },
    handleClickMoreSettings() {
      buryPoint({
        function_module: 'moreSettings',
        function_point: 'click_more_settings',
      })
    },
    translateLang(key) {
      return translate(key)
    },
    // 打开公告
    handleOpenNotice() {
      this.$refs.noticeRef.openNotice()
    },
    // 前往官网
    handleGotoOfficialWebsite() {
      if (this.showTiangong) {
        window.open('https://www.guigui.com.cn/tiangong_official/tiangong.html')
      } else {
        window.open('http://www.bluen.cn')
      }
    },
    //跳转到机器设备
    handleGotoOfficialEquipEnvironment() {
      const { href } = this.$router.resolve({
        path: `/equipEnvironment`,
      })
      window.open(href, '_blank')
    },
    //跳转到帮助文档
    gotoHelpingDocument() {
      _hmt.push(['_trackEvent', '帮助', 'click'])
      window.open('https://www.yuque.com/linyaoyu/vr6nhn/beohd8')
    },
    handleGotoThinkerxHome() {
      window.open('http://www.thinkerx.com/')
    },
    /**
     * @desc 打开重要功能弹窗
     */
    hanlerOpenImportFuncModal() {
      this.$store.commit('setImportFunc', true)
    },
    // 是否在加载语言
    handleReloadLang(isReloadLang) {
      if (!isReloadLang) {
        setTimeout(() => {
          this.isReloadLang = isReloadLang
        }, 500)
      } else {
        this.isReloadLang = isReloadLang
      }
    },
    //修改个人中心弹窗显隐
    hideUserInfo() {
      if (this.$store.state.showPerson) {
        this.$store.commit('setShowPerson', false)
      }
      if (this.$store.state.isShowSettingPop) {
        this.$store.commit('setShowSettingPop', false)
      }
      if (this.$store.state.isShowFindPop) {
        this.$store.commit('setShowFindPop', false)
      }
      if (this.$store.state.isShowHelp) {
        this.$store.commit('setIsShowHelp', false)
      }
    },
    // 保存用户token
    saveUserToken() {
      if (this.$route.query.guigui_token) {
        window.sessionStorage.setItem('token', this.$route.query.guigui_token)
      }
    },
    // 获取版本
    getVersion() {
      this.$get('/latest_bluen_version', {}, (res) => {
        if (res.status == 1) {
          this.version = res.data.version
          this.setNewTags(res.data.new_feature_tag)
        }
      })
    },
    handleFeedback(showFeedback) {
      this.showFeedback = showFeedback
    },
    handleShowFeedback() {
      this.showFeedback = true
      this.$refs.feedback.getFeedbackData()
    },
    handleTaskList() {
      if (this.$route.path !== '/taskList') {
        if (!this.hasSendToTask && this.preLayoutData.length) {
          this.sendTaskModal = this.$antdConfirm({
            title: this.$t('common.tip'),
            content: this.$t('materialPage.createTaskCard'),
            okText: this.$t('common.confirm'),
            cancelText: this.$t('common.cancel'),
            centered: true,
            closable: true,
            onOk: () => {
              this.isTaskLoading = true
              createTask(this.preLayoutData).then(() => {
                this.isTaskLoading = false
                this.setHasSendToTask(true)
                this.$router.push('/taskList')
                buryPointApi('task', 'creat_task')
              })
            },
            onCancel: (e) => {
              this.handleCancelToTask(e)
            },
          })
        } else {
          this.$router.push('/taskList')
        }
      }
    },
    handleToSurplus() {
      this.$router.push('/supplusStorage')
    },
    handleToPaiban() {
      this.$router.push('/newPaiban')
    },
    handleCancelToTask(e) {
      const isCancel = typeof e == 'function'
      this.sendTaskModal && this.sendTaskModal.destroy()
      if (isCancel) {
        this.$router.push('/taskList')
      }
    },
    async getNoReadNotice() {
      this.$refs.noticeRef.init()
    },
    handleClickPreSetting(event) {
      this.isNewSettingRecord = true
      this.$router.push('/preLayoutSetting')
    },
    handleToSfe() {
      const params = {
        platform: 'bluen',
        token: window.sessionStorage.getItem('token'),
        isSelectDeepSeek: true,
      }
      // 定义 URL 参数
      const urlParams = `?platform=${params.platform}&token=${params.token}&isSelectDeepSeek=${params.isSelectDeepSeek}`
      if (window.webToQt) {
        // 柜柜客户端
        buryPoint({
          function_module: 'deepseekQT',
          function_point: 'deepseekqt',
        })

        const gg_version =
          sessionStorage.getItem('guigui_version') || '4.0.0.3-17'
        const pageName =
          compareVersions(gg_version, '4.0.0.3-17') === 1 ? 'deepSeek' : 'chat'

        if (window.mainBridge?.openSFETaskByParams) {
          window.mainBridge.openSFETaskByParams({
            urlParams,
            pageName,
          })
        } else {
          this.$antdConfirm({
            content: translate('common.versionErrTip'),
          })
          return
        }
      } else {
        // ypb 网页端
        buryPoint({ function_module: 'deepseek', function_point: 'deepseekPC' })
        window.open(
          `${process.env.VUE_APP_TO_SFE_URL}/deepSeek/${urlParams}`,
          '_blank'
        )
      }
    },
    // 跳转到顺风耳排版公社
    handleToSfeCommune() {
      const token = window.sessionStorage.getItem('token')
      // 定义 URL 参数
      const urlParams = `?type=commune&communeId=-21&token=${encodeURIComponent(
        token
      )}`
      if (window.webToQt) {
        // 柜柜客户端
        buryPoint({
          function_module: 'layout',
          function_point: 'communicationGroupToQt',
        })

        const pageName = 'chat'

        if (window.mainBridge?.openSFETaskByParams) {
          window.mainBridge.openSFETaskByParams({
            urlParams,
            pageName,
          })
        } else {
          this.$antdConfirm({
            content: translate('common.versionErrTip'),
          })
        }
      }
    },
  },
  watch: {
    '$route.meta': function (newVal, oldVal) {
      if (newVal.hideHead) {
        this.showHead = false
      } else {
        this.showHead = true
      }
    },
  },
  mounted() {
    const currentLang = sessionStorage.getItem('lang')
    if (currentLang) {
      this.langTitle =
        this.langList.find((item) => item.value === currentLang)?.name ??
        '中文(Chinese)'
    }

    if (this.$route.meta.hideHead) {
      this.showHead = false
    } else {
      const isFirstNotice = sessionStorage.getItem('firstNotice')
      const showSpecificFunc = sessionStorage.getItem('showSpecificFunc')
      // 首次加载后或者有特殊公告弹窗 都不再弹出
      if (!isFirstNotice || showSpecificFunc !== 'true') {
        this.getNoReadNotice()
      }
    }
    if (this.$route.query.from) {
      if (this.$route.query.from == 'tiangong') {
        this.showTiangong = true
      }
    } else {
      this.showTiangong = false
      this.saveUserToken()
    }
  },
  created() {
    document.title = '云排版'
    this.webToQt = window?.webToQt
    if (this.$route.query) {
      if (this.$route.query.from == 'tiangong') {
        document.title = '天工'
      }
    }
    const settingStorage = localStorage.getItem('newSettingRecord')
    const userInfo = this.$store.state.userInfo
    this.isNewSettingRecord =
      settingStorage &&
      JSON.parse(settingStorage)[userInfo.id] &&
      JSON.parse(settingStorage)[userInfo.id]['hasClickPreSetting']

    this.getVersion()
  },
}
</script>

<style scoped lang="less">
#home {
  /* min-width: 1440px; */
  width: 100%;
  background: #eee;
}

.factory-tip {
  right: 30px;
}
#components-layout-demo-custom-trigger {
  .trigger {
    padding: 0 16px;
    color: #fff;
    //导航栏头部左边样式
    font-size: 24px;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #18a8c7;
    }
  }
  .topNav-btn {
    color: #fff;
  }
  .topNav-text {
    color: #fff;
    &:hover {
      color: #18a8c7;
    }
  }
  .topNav-btn:hover,
  .active-topNav {
    background-color: #4c4c4c;
  }
  .logo {
    //导航栏左边logo样式
    display: flex;
    gap: 8px;
    align-items: flex-start;
    // margin: 16px;
    width: 100%;
    height: 60px;
    // justify-content: center;
    // padding: 10px 0 0 16px;
    background: #212121;
    // background: rgba(255, 255, 255, 0.2);
    img {
      display: block;
      border-radius: 6px;
    }
    div.text {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 40px;
      line-height: 1;
      h3 {
        // line-height: 28px;
        margin-bottom: 0;
        color: #fff;
        font-weight: 500;
        font-size: 20px;
        font-family: 'PingFangSC-Medium', 'PingFang SC';
        letter-spacing: 1px;
      }
      span {
        color: #fff;
        font-weight: 400;
        font-size: 12px;
        font-family: 'PingFangSC-Regular', 'PingFang SC';
        // line-height: 17px;
      }
      .version {
        font-weight: 400;
        font-size: 13px;
      }
    }
  }

  section.ant-layout header.ant-layout-header {
    //导航栏头部样式
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 800px;
    z-index: 999;
  }
  /deep/ .ant-layout-sider-children {
    // overflow-y: auto;
    display: flex;
    flex-direction: column;
    height: 100vh;
    .ant-menu-root {
      flex: 1;
      height: 0;
      overflow-y: auto;
      background: #eee;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .ant-menu-inline {
      background: #eee;
    }
    #feedback_showFeedback_div {
      left: 135px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #1f1f1f;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
      transition: all 0.3s ease;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: linear-gradient(145deg, #272727, #141414);
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5),
          0px 8px 15px rgba(0, 0, 0, 0.2);
        z-index: -1;
        transition: all 0.3s ease;
      }
      &:hover {
        transform: translateY(-5px);
      }
      &:hover::before {
        box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.5),
          0px 12px 20px rgba(0, 0, 0, 0.25);
      }
      i {
        color: #fff;
        font-size: 26px;
      }
    }
  }
  /deep/ ul.ant-menu.ant-menu-vertical {
    border: none;
  }
  /deep/ ul.ant-menu.ant-menu-inline {
    //导航栏左侧菜单
    border: none;
    > li {
      &.item-sub-menu {
        //有子菜单的样式
        div.ant-menu-submenu-title {
          //有子菜单的菜单标题
          padding-left: 16px !important;
          text-overflow: ellipsis;
          overflow: hidden;
          > span {
            padding-left: 17px;
            i {
              color: #a3a5b4;
            }
            span {
              padding-left: 3px;
              color: #333333;
              font-weight: 400;
              font-size: 14px;
              font-family: 'PingFangSC-Regular', 'PingFang SC';
            }
          }
          > i::after,
          > i::before {
            //箭头
            background-image: linear-gradient(to right, #a3a5b4, #a3a5b4);
          }
        }
        .preLayout-setting {
          overflow: unset !important;
          .new-button {
            width: 100%;
          }
          a {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
        }
        &.ant-menu-submenu-active {
          //悬浮在子菜单item项时item的样式
          div.ant-menu-submenu-title {
            color: #18a8c7;
            > span {
              padding-left: 17px;
              i {
                color: #18a8c7;
              }
              span {
                color: #18a8c7;
              }
            }
            > i::after,
            > i::before {
              //箭头
              background-image: linear-gradient(to right, #18a8c7, #18a8c7);
            }
          }
        }
        ul li.ant-menu-item-active a {
          color: #18a8c7;
        }
        ul li.ant-menu-item {
          padding-left: 16px !important;
          a {
            padding-left: 40px;
            text-overflow: ellipsis;
            overflow: hidden;
            color: rgba(0, 0, 0, 0.65);
          }
          /* 角标绝对定位在链接右侧，需放开 overflow 避免被裁切 */
          &.paiban-task-menu-item {
            overflow: visible !important;
            a.paiban-task-menu-item__link {
              overflow: visible !important;
            }
            .__disabled {
              color: rgba(0, 0, 0, 0.25) !important;
            }
          }
        }
        &.ant-menu-submenu-selected {
          //item项被选中时的样式
          div.ant-menu-submenu-title {
            > span {
              padding-left: 17px;
              i {
                color: #18a8c7;
              }
              span {
                color: #18a8c7;
              }
            }
            > i::after,
            > i::before {
              //箭头
              background-image: linear-gradient(to right, #18a8c7, #18a8c7);
            }
          }
          ul li.ant-menu-item-selected {
            background-color: transparent;
            &::after {
              border: none;
            }
            a {
              color: #fff;
              background: #18a8c7;
              border-radius: 4px;
            }
          }
        }
      }
      &.item-single {
        //没有子菜单的样式
        padding-left: 16px !important;
        text-overflow: ellipsis;
        overflow: hidden;
        a {
          padding-left: 18px;
          color: #ffffff;
          font-weight: 400;
          font-size: 14px;
          font-family: 'PingFangSC-Regular', 'PingFang SC';
          background: transparent;
          border-radius: 4px;
          i {
            color: #a3a5b4;
          }
          span {
            padding-left: 3px;
            color: #333;
          }
        }
        &.ant-menu-item-active a {
          //没有子菜单的选中悬浮的样式
          i,
          span {
            color: #18a8c7;
          }
        }
        &.ant-menu-item-selected {
          //没有子菜单的选项被选中时的样式
          background-color: transparent;
          &::after {
            border: none;
          }
          a {
            background: #18a8c7;
            i,
            span {
              color: #ffffff;
            }
          }
        }
      }
    }
  }
  /deep/ ul.ant-menu-inline-collapsed {
    //折叠起来的样式
    li {
      background-color: transparent;
      &.ant-menu-submenu-selected {
        div.ant-menu-submenu-title > span {
          color: #18a8c7;
        }
      }
      &.ant-menu-item-selected {
        a i {
          color: #18a8c7;
        }
      }
    }
  }
}
.imgWrite {
  right: -10px;
}
.active {
  color: #a8a4a4 !important;
}
/deep/ .ant-layout-content {
  overflow-x: auto !important;
}
/deep/ .ant-layout::-webkit-scrollbar {
  display: none;
  // opacity: 0;
}
/deep/ .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 30px;
  line-height: 30px;
  list-style-position: inside;
  list-style-type: disc;
}
.new_button_text {
  background-color: red;
  border-radius: 3px;
  color: white;
  height: 24px;
  text-align: center;
  min-width: 40px;
  padding: 3px;
  line-height: 18px;
}

/deep/ .ant-menu-item-selected {
  #pre_layout_setting_btn {
    color: #fff;
    background: #18a8c7;
    border-radius: 4px;
  }
}
.deep_item {
  margin: 5px 0;
  width: 100% !important;
  line-height: 100% !important;
  padding-left: 16px !important;
  .deepbox {
    display: flex;
    flex-direction: column;
    padding-left: 17px;
    img {
      width: 80px;
      object-fit: cover;
    }
    div {
      width: 80px;
      margin-top: 5px;
      margin-left: 22px;
      height: fit-content;
      background: linear-gradient(270deg, #ca37ce, #335bff);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }
  }
}
.search-container {
  width: 180px;
  margin-right: 30px;
  display: inline-block;
}
.search-trigger {
  display: flex;
  align-items: center;
  padding: 7px 12px;
  background: #f0f2f5;
  border: 1px solid #666666;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
  width: 100%;
  transform-origin: center;
  background: #4c4c4c;
  margin-left: auto;
}

.trigger-icon,
.trigger-text {
  color: #8c8c8c;
}

.trigger-icon {
  font-size: 16px;
  color: #b8b8b8;
}

.trigger-text {
  margin-left: 8px;
  font-size: 14px;
}
.lang-link-btn {
  cursor: pointer;
}
/deep/.new-button_text {
  top: 0;
}
.trigger-fade-enter-active {
  transition: all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.trigger-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.trigger-fade-enter {
  opacity: 0;
  transform: scaleX(0);
}

.trigger-fade-enter-to {
  opacity: 1;
  transform: scaleX(1);
}

.trigger-fade-leave {
  opacity: 1;
  transform: scaleX(1);
}

.trigger-fade-leave-to {
  opacity: 0;
  transform: scaleX(0);
}

/* 排版任务：文字与角标横向排列，避免 badge 包裹文字导致省略 */
.paiban-task-menu-item {
  overflow: visible !important;

  /deep/ a.paiban-task-menu-item__link {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    overflow: visible !important;
    box-sizing: border-box;
  }

  &__text {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__badge {
    flex-shrink: 0;
    line-height: 1;

    /deep/ .ant-badge-count {
      position: static;
      transform: none;
      box-shadow: none;
    }
  }
}
</style>
